import { StrictMode } from 'react';
import { Providers } from '@/providers';
import { ConfigProvider } from '@/contexts/ConfigContext';
import { AppConfig } from '@/AppConfig';

interface AppProps {
  config?: AppConfig;
}

function App({ config }: AppProps) {
  return (
    <StrictMode>
      <ConfigProvider config={config}>
        <Providers>{/* add new content */}</Providers>
      </ConfigProvider>
    </StrictMode>
  );
}

export default App;
